import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'

export default function PrivateLoginRoute() {
    let  userid = localStorage.getItem("token") == null ? true : false;
    let role = parseInt(localStorage.getItem("role"));
    if(userid===true)
    { 
	       return (
			<>
				{userid ? <Outlet  /> : <Navigate to="/neighbour/local-deals" />}
			</>
            )
	}else{
        if(role===1)
        {
            return <><Navigate to="/neighbour/local-deals" /></>;
        }else if(role===2)
        {
            return <><Navigate to="/business/edit-business" /></>;
        }
	}
}